
<template>
    <div class="center examplex">
        <!-- <vs-row v-if="users[0]">
            <vs-col sm="12" lg="3" class="ml-auto">
                <vs-button
                    class="ml-auto"
                    relief
                    success
                    :loading="loadingExcel"
                    @click="getExcel"
                >
                    Descargar reporte
                </vs-button>
            </vs-col>
        </vs-row> -->
        <vs-row>
            <vs-col sm="12" lg="3" class="ml-auto">
                <vs-input class="ml-auto" v-model="search" placeholder="Buscar">
                    <template #icon>
                        <i class="fas fa-search"></i>
                    </template>
                </vs-input>
            </vs-col>
        </vs-row>
        <vs-table striped>
            <template #thead>
            <vs-tr>
                <vs-th style="width: 30%;">
                    Alumno
                </vs-th>
                <vs-th style="width: 55%;">
                    Documento
                </vs-th>
                <vs-th style="width: 15%;">
                    
                </vs-th>
                <vs-th></vs-th>
            </vs-tr>
            </template>
            <template #tbody>
            <vs-tr
                :key="i"
                v-for="(tr, i) in $vs.getSearch(users, search)"
                :data="tr"
                style="border-bottom: 1px solid #D7DBDD"
            >
                <vs-td style="vertical-align: top">
                    <vs-row>
                        <vs-col w="2">
                            <vs-avatar circle class="m-auto">
                                <img :src="'/api/personas/' + tr.persona_id + '/avatar'" @error="setAltImg" alt="">
                            </vs-avatar>
                        </vs-col>
                        <vs-col w="10" class="pl-2">
                            <p class="mb-1"><strong>{{ tr.nombre }}</strong></p>
                            <p class="mb-0"><small>MATRÍCULA</small></p>
                            <p class="mb-0"><strong>{{ tr.matricula }}</strong></p>
                        </vs-col>
                    </vs-row>
                </vs-td>
                <vs-td style="vertical-align: top">
                    <vs-row v-for="(doc, x) in tr.documentos" :key="x" :class="tr.documentos.length > 1 ?'divisionLineas' : ''">
                        <vs-col w="6" style="padding-right:1%;">
                            <p class="mb-0 text-uppercase"><small>Nombre</small></p>
                            <p class="mb-1"><strong>{{ doc.nombre}}</strong></p>
                            <vs-button
                                v-if="doc.archivo_cargado"
                                success
                                flat
                                @click="downloadContestada(doc.documento_id, tr.persona_id)"
                            >
                                Descargar documento
                            </vs-button>
                        </vs-col>
                        <vs-col w="6" style="padding-left:1%;">
                            <div v-if="doc.status_carga != ''">
                                <p class="mb-0 text-uppercase"><small>Estatus</small></p>
                                <md-chip class="mini-chip text-uppercase col-green mb-2"><strong> {{ doc.status_carga }} </strong></md-chip>
                            </div>
                            <div v-if="doc.fecha_actualizacion != '' && doc.fecha_actualizacion != 'no_enviado'">
                               <p class="mb-0 text-uppercase"><small>Fecha de actualización</small></p>
                                <p class="mb-1"><strong>{{ doc.fecha_actualizacion.split('T')[0]}}</strong></p> 
                            </div>
                            <div v-if="doc.fecha_actualizacion == 'no_enviado'">
                                <p>No contiene documento cargado </p>
                            </div>
                        </vs-col>
                    </vs-row>
                </vs-td>
                <vs-td style="vertical-align: top">
                     <vs-button
                        v-if="tr.persona_id" 
                        blank
                        flat
                        :href="`/panel/alumno/${window.btoa(tr.persona_id)}/institucion/${window.btoa(institucion)}?valor=expediente-digital`"
                    >
                        Expediente digital
                    </vs-button>
                </vs-td>
            </vs-tr>
            </template>
            <template #notFound>
                Sin información
            </template>
        </vs-table>
    </div>
</template>
<script>
    export default {
        props: [
            'users',
            'institucion',
            'cicloEscolar',
            'grupo'
        ],
        data:() => ({
            search: '',
            loadingExcel: false
        }),
        methods:{
            
            
            async downloadContestada(id,persona_id){
                const loading = this.$vs.loading()
                const vue = this
                const url = '/panel/expediente-digital/descargar-archivo/'+ id +  '/' + persona_id
                $.ajax({ url:'/panel/expediente-digital/descargar-archivo/'+ id +  '/' + persona_id, type:'HEAD', error: function() { 
                    vue.$vs.notification({
                        progress: 'auto',
                        color: 'danger',
                        position: 'bottom-right',
                        title: 'Archivo no encontrado'
                    })
                }, 
                success: function() { 
                    window.location.href = url;
                    } });
                loading.close()
            },
            
            getExcel () {
                this.loadingExcel = true
                let formData = {
                    'institucion_id': this.institucion,
                    'ciclo_escolar_id': this.cicloEscolar,
                    'type_response': 'file'
                }

                if(this.grupo[0] == ''){
                    const eliminarGrupo = this.grupo.shift()
                    formData.grupo_id = this.grupo
                }else{
                    formData.grupo_id = this.grupo
                }

                this.loading = true
                setTimeout(() => {
                    axios.get('/reportes-academicos/getSeguimientoCobranzaAlumnosPorGrupoAcademico', {
                        responseType: 'blob',
                        params: {...formData},
                        // responseType: 'arraybuffer',
                    }).then(response => {
                        this.loadingExcel = false
                        if (response.data instanceof Blob) {
                            const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));
                            const link = document.createElement('a');
                            link.href = downloadUrl;
                            var filename = "";
                            const disposition = response.headers['content-disposition'];
                            if (disposition && disposition.indexOf('attachment') !== -1) {
                                const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                                const matches = filenameRegex.exec(disposition);
                                if (matches != null && matches[1]) {
                                    filename = matches[1].replace(/['"]/g, '');
                                    link.setAttribute('download', filename)
                                }
                            }
                            document.body.appendChild(link);
                            link.click();
                            link.remove();
                        }else{
                            throw { message: 'formatError' }
                        }
                        this.$vs.notification({
                            progress: 'auto',
                            color: 'success',
                            position: 'bottom-right',
                            title: 'Éxito',
                            text: 'Descarga lista'
                        })
                        this.loading = false;
                    }).catch(e => {
                        this.loadingExcel = false
                        this.$vs.notification({
                            progress: 'auto',
                            color: 'danger',
                            position: 'bottom-right',
                            title: 'Ocurrió un problema inesperado'
                        })
                    });
                }, 500);
            },
            setAltImg(event) {
                event.target.src = "https://sigem.maristas.mx/img/default-avatar.jpg"
            },
        },
    }
</script>

<style scoped>
.vs-avatar img{
    object-fit: contain;
}
</style>

<style lang="scss" scoped>
    .col-yellow{
        background: rgb(255, 248, 236);
        color: #febf3d;
    }

    .col-green{
        color: #55ce63;
        background: rgb(232, 253, 235);
    }

    .col-red{
        color: #f62d51;
        background: rgb(249, 231, 235);
    }

    .divisionLineas:not(:last-child){
        border-bottom: 1px solid #E5E7E9; 
    }
    .divisionLineas{
        padding: 2% 0;
    }
    .vs-avatar img{
        object-fit:contain;
    }
</style>

        